module.exports = __webpack_public_path__ + "assets/img/Amaze-Wholesale-1-Landing-Page-w540.83004098.jpg";